import React from 'react'
import toastr from 'toastr'
import { SubscriptionContext } from '../../context'
import { Stack } from '@UILibrary/Stack'
import { Button } from '@components/Button'
import useRemainingTime from '@hooks/useRemainingTime'

const baseClass = "card-details"

const CardDetails = () => {
  const { 
    actions: {
      navigateToIndex
    },
    state: { 
      checkout: {
        id: checkoutId,
        timestamp: checkoutTimestamp,
        baseUrl: checkoutUrl
      },
      paths: { 
        registerCardRedirectUrl
      }
    }
  } = React.useContext(SubscriptionContext)

  const scriptId = 'payment-widget-script'
  toastr.options.positionClass = 'toast-footer-small'

  const { formattedTime, setTimestamp } = useRemainingTime({ 
    format: "mm:ss", 
    onTimeUp: () => {
      toastr.warning("Session has expired, please try again.")
      navigateToIndex();
    }
  })

  React.useEffect(() => {
    if (!checkoutId) return;

    let oldScript = document.getElementById(scriptId);

    if (oldScript) {
      document.body.removeChild(oldScript);
    }

    const script = document.createElement('script');
    script.id = scriptId;
    script.src = `${checkoutUrl}/paymentWidgets.js?checkoutId=${checkoutId}`;
    script.async = true;
  
    document.body.appendChild(script);
  
    return () => {
      document.body.removeChild(script);
    }
  }, [checkoutId]);
  

  React.useEffect(() => {
    // Add 30 min to timestamp
    setTimestamp(new Date(checkoutTimestamp).getTime() + 30 * 60 * 1000)
  }, [checkoutTimestamp]);


  return (
    <div>
      <div className={`${baseClass}__capture-container`}>
        <div className={`${baseClass}__breakdown-wrapper`}>
          <p>Please fill in your card details to be used for the monthly subscription charge. This card will be charged on the <strong>1st of the month</strong>, based on the months running invoice which will be sent to the email address provided in the billing information.</p>
          <small>If you would like any further information about this process, please contact us at <a href="mailto: support@wealthbit.co">support@wealthbit.co</a>.</small>
          <p className={`${baseClass}__breakdown-wrapper__timer`}>Remaining Time: {formattedTime}</p>
        </div>
        <div className={`${baseClass}__divider`} />
        <div className={`${baseClass}__form-wrapper`}>
          <form action={`${registerCardRedirectUrl}`} className={`paymentWidgets ${baseClass}__capture-form`} data-brands="VISA MASTER AMEX"></form>
        </div>
      </div>
    </div>
  );
}

const CardDetailsActions = () => {
  const { actions: { navigateToIndex } } = React.useContext(SubscriptionContext)
  
  return (
    <Stack horizontal space="s">
      <Button secondary onClick={() => navigateToIndex() }>Cancel</Button>
    </Stack>
  ) 
}

export { CardDetails, CardDetailsActions }